//资源库首页最新上传组件
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Icon, Modal} from 'antd';
import BaseComponent from '../../../../base/BaseComponent';
import Titlepicfile from '../../../components/titlepicfile/Titlepicfile'
import {formatSecondsFont, unitConvert} from "../../../../utils";

const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
};

export default class UploadItem extends BaseComponent {
    static defaultProps = {
        checked: false,
        name: 'tttppp',
        size: '2.2M',
        pixel: '1920 x 1060',
        img: 'images/folder.png',
        width: '1200',
        height: '790',
        onClick: () => {
            console.log("点击");
        },
        IsChecked: () => {

        },
        onDownloadCall: () => {
        },
        file: {}
    };

    static propTypes = {
        name: PropTypes.string.isRequired,//传入dom 结构
        size: PropTypes.string.isRequired,//文件大小
        pixel: PropTypes.string.isRequired,//图片像素
        onClick: PropTypes.func,//点击函数
        IsChecked: PropTypes.func.isRequired,//选中的函数
        img: PropTypes.string.isRequired,//传入图标
        downloadImg: PropTypes.string,//下载的图标
        download: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.state = {
            hover: false,
            picDown: ""
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    handleEnter() {
        this.setState({hover: true})
    }

    handleOut() {
        this.setState({hover: false})
    }


    render() {
        // 鼠标划过
        return (
            <div>
                {this.renderFileCard()}
            </div>)
    }

    renderFileCard() {
        let show;
        if (this.state.hover) {
            show = 'block'
        } else {
            show = 'none'

        }
        // 鼠标划过
        return (
            <div style={{width: '104px'}} onMouseOver={() => this.handleEnter()}
                 onMouseOut={() => this.handleOut()}>
                <div style={{marginBottom: '8px', cursor: "pointer", width: '104px', position: "relative"}}
                >
                    <div onClick={() => {
                        this.props.onClick()
                    }}>
                        <Titlepicfile style={{width: '104px', height: '104px'}} src={this.props.file['icon']}/>
                        <div style={{
                            display: show,
                            width: '104px',
                            height: '104px',
                            background: "rgba(0,0,0,0.40)",
                            position: "absolute",
                            top: 0,
                            zIndex: '2',
                            color: '#ffffff',
                        }}>
                            <div style={{
                                display: "flex",
                                margin: '40px auto 0 auto',
                                justifyContent: "space-around",
                                width: '50px'
                            }}>
                                <div><Icon type="eye"/></div>
                                <div><Icon type="arrow-down"/></div>
                            </div>


                        </div>
                    </div>
                </div>

                <div style={{textAlign: 'center', lineHeight: '18px', marginTop: 8}}>
                    <div className={'twoText'} style={{
                        fontSize: '14px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        color: "rgba(0, 0, 0, 0.65)"
                    }} title={this.props.file['name']}>{this.props.file['name']}</div>
                    <div style={{
                        fontSize: '12px',
                        color: "rgba(0, 0, 0, 0.45"
                    }}>{this.props.file.size ? unitConvert(this.props.file['size']) : '0B'}</div>
                </div>
                <Modal
                    visible={this.state.previewVisible}
                    footer={null}
                    onCancel={() => this.setState({previewVisible: false})}>
                    <div>

                        {
                            this.props.type === 1 ?
                                <img alt="example" style={{width: '100%'}} src={this.state.previewImage}/> :
                                <video controls={"controls"} style={{width: '100%'}} src={this.state.previewImage}/>
                        }
                    </div>
                </Modal>

            </div>


        )
    }

    handlePreview = async file => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        } else {
            file.url = file.path
        }

        this.setState({
            previewImage: file.url || file.preview,
            previewVisible: true,

        });
    };
    onDownload = (file) => {
        if (file.url.indexOf("?") === -1) {
            window.location.href = file.url + "?download=1";
        } else {
            window.location.href = file.url + "&download=1";
        }
    }

}
